import { render, staticRenderFns } from "./orDivideInto.vue?vue&type=template&id=c3f3bf8a&scoped=true"
import script from "./orDivideInto.vue?vue&type=script&lang=js"
export * from "./orDivideInto.vue?vue&type=script&lang=js"
import style0 from "./orDivideInto.vue?vue&type=style&index=0&id=c3f3bf8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f3bf8a",
  null
  
)

export default component.exports